export default class SavedInsightService {
  /** @ngInject **/
  constructor(
    _,
    $q,
    $http,
    ngAuthSettings,
    promiseCacheService
  ) {
    this._ = _;
    this.$http = $http;
    this.$q = $q;
    this.ngAuthSettings = ngAuthSettings;
    this.promiseCacheService = promiseCacheService;
    
    this.savedInsights = [];
    this.cacheKey = 'insights-';
  }

  async saveReport(accountId, insight) {
    if (insight.id) { // Update
      return this.$http.put(this.#getBaseUrl(accountId) + insight.id, insight)
        .then(function (response) {
          return response.data.savedInsight;
        }).catch((error) => {
          if (error.status === 404) {
            throw {
              data: { message: 'Only the user who created the report can update it' }
            };
          }

          return error;
        });
    }
    // Create
    return this.$http.post(this.#getBaseUrl(accountId), insight)
      .then(function (response) {
        return response.data.savedInsight;
      });
  }

  async duplicateReport(accountId, insight) {
    const duplicatedInsight = this._.cloneDeep(insight);
    duplicatedInsight.id = null;
    duplicatedInsight.name = `${insight.name}-copy`;
    return this.saveReport(accountId, duplicatedInsight);
  }

  async getInsights(accountId) {
    return this.promiseCacheService.getCallWithCachedPromise(this.cacheKey, this.#getBaseUrl(accountId), 3600)
      .then((response) => {
        return response.data.savedInsights;
      }).catch((response) => {
        return this.$q.reject(response);
      });
  }

  async getInsight(accountId, insightId) {
    return this.promiseCacheService.getCallWithCachedPromise(this.cacheKey + insightId, this.#getBaseUrl(accountId) + insightId, 3600)
      .then((response) => {
        return response.data.savedInsight;
      }).catch((response) => {
        return this.$q.reject(response);
      });
  }

  async deleteReport(accountId, insightId) {
    const me = this;
    return this.$http.delete(this.#getBaseUrl(accountId) + insightId).then(function(response){
      me.promiseCacheService.clean(me.cacheKey + insightId);
      return response.data;
    }).catch(function () {
      return me.$q.reject({ data: { message: 'Unable to delete saved report' } });
    });
  }

  #getBaseUrl (accountId) {
    return this.ngAuthSettings.apiServiceBaseUri + accountId + '/savedInsights/';
  }
}
